import { Box, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Typography } from "@mui/material";
import CryptoJS from "crypto-js";
import { useState } from "react";
import { getUserData } from "../../Actions/common";
import BreadcrumbsComponent from "../../components/Common/Breadcrumbs";
import { CRYPTO_TOKEN_SECRET_KEY } from "../../config";
import TransactionReportModel from "./TransactionReport";
import { MyAssessmentIcon } from "../../Assets/svg/MyIcons";

const getPermissionData = (key) => {
  const decryptedData = CryptoJS.AES.decrypt(localStorage.getItem(key), CRYPTO_TOKEN_SECRET_KEY).toString(CryptoJS.enc.Utf8);
  return JSON.parse(decryptedData);
};

const ReportsSection = () => {
  const userData = localStorage.getItem("userData") ? getUserData() : null;
  const permission = localStorage.getItem(`${userData?.id}_permissionData`) ? getPermissionData(`${userData?.id}_permissionData`) : [];

  const transactionReportModule = permission[0]?.role_permissions?.find((m) => m?.module && m?.module?.slug === "transaction");
  const payoutReportModule = permission[0]?.role_permissions?.find((m) => m?.module && m?.module?.slug === "withdrawal");
  const paymentHistoryReportModule = permission[0]?.role_permissions?.find((m) => m?.module && m?.module?.slug === "payment-history");

  const [openModal, setOpenModal] = useState(
    transactionReportModule?.canView ? "Transaction Report" : payoutReportModule?.canView ? "Payout Report" : paymentHistoryReportModule?.canView ? "Payment History Report" : ""
  );

  const handleOpenModal = (reportName) => {
    setOpenModal(reportName);
  };



  return (
    <>
      <BreadcrumbsComponent />
      <Box>
        {/* Horizontal Menu wrapped in Card */}
        <div className="card">
          <div className="card-body p-0">
            {/* <h2  className="chart-title mb-5 " mb={1}>
                            Custom Reports
                        </h2> */}
            <List className="d-flex py-0  rounded">
              {transactionReportModule?.canView && (
                <ListItem
                  disablePadding
                  className={openModal === "Transaction Report" ? "active" : ""}
                >
                  <ListItemButton onClick={() => handleOpenModal("Transaction Report")}>
                    <ListItemIcon>
                      <MyAssessmentIcon color="#344d95" /> {/* Changed to primary for blue theme */}
                    </ListItemIcon>
                    <ListItemText primary="Transaction Report" />
                  </ListItemButton>
                </ListItem>
              )}
            </List>
            {/* Main Content */}
          </div>
        </div>

        <Box py={3}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={2}
          >
            <Typography
              variant="h4"
              gutterBottom
            >
              {openModal || "Reports"}
            </Typography>
          </Box>

          {openModal === "Transaction Report" && <TransactionReportModel />}
        </Box>
      </Box>
    </>
  );
};

export default ReportsSection;
